import { Font, StyleSheet } from '@react-pdf/renderer';
Font.register({
  family: 'Lato',
  fonts: [
    { src: '/Lato-Thin.ttf', fontWeight: 100 },
    { src: '/Lato-Light.ttf', fontWeight: 300 },
    { src: '/Lato-Regular.ttf', fontWeight: 400 },
    { src: '/Lato-Bold.ttf', fontWeight: 700 },
    { src: '/Lato-Black.ttf', fontWeight: 900 },
    { src: '/Lato-ThinItalic.ttf', fontWeight: 100, fontStyle: 'italic' },
    {
      src: '/Lato-LightItalic.ttf',
      fontWeight: 300,
      fontStyle: 'italic',
    },
    {
      src: '/Lato-RegularItalic.ttf',
      fontWeight: 400,
      fontStyle: 'italic',
    },
    { src: '/Lato-BoldItalic.ttf', fontWeight: 700, fontStyle: 'italic' },
    {
      src: '/Lato-BlackItalic.ttf',
      fontWeight: 900,
      fontStyle: 'italic',
    },
  ],
});

Font.register({
  family: 'WeIconFont',
  src: '/we-icons.ttf',
});

Font.register({
  family: 'FontAwesome',
  src: '/fa-solid-900.ttf',
});

export const styles = StyleSheet.create({
  page: {},
  contentWrapper: {
    paddingTop: 10,
    paddingHorizontal: 40,
    marginTop: 20,
    width: '100%',
  },
  icon: {
    color: '#27343d',
    fontFamily: 'WeIconFont',
    fontSize: 12,
  },
  whiteIcon: {
    backgroundColor: 'black',
    borderRadius: '50%',
    color: 'white',
    fontFamily: 'FontAwesome',
    fontSize: 10,
    transform: 'scale(1.1)',
    padding: '13 10',
  },

  targetGroupsBackgroundWrapper: {
    position: 'relative',
    width: '100%',
    marginTop: 10,
  },
  targetGroupsBackgroundImage: {
    position: 'absolute',
    top: 0,
    left: 0,
    right: 0,
    bottom: 0,
    width: '100%',
    height: '100%',
    objectFit: 'cover',
    opacity: 0.7,
  },

  targetGroupsWrapper: {
    display: 'flex',
    flexDirection: 'row',
    flexWrap: 'wrap',
    gap: 5,
    justifyContent: 'flex-start',
  },
  targetGroupsItem: {
    display: 'flex',
    flexDirection: 'column',
    gap: 12,
    width: 118,
  },
  targetGroupsHeader: {
    display: 'flex',
    flexDirection: 'row',
    alignItems: 'center',
    justifyContent: 'flex-start',
    gap: 4,
  },

  titleText: {
    color: '#27343d',
    fontFamily: 'Lato',
    fontWeight: 900,
    fontSize: 20,
    textAlign: 'left',
  },
  boldText: {
    color: '#27343d',
    fontWeight: 900,
    fontSize: 16,
    fontFamily: 'Lato',
  },
  regularText: {
    color: '#27343d',
    fontFamily: 'Lato',
    fontWeight: 400,
    fontSize: 13,
  },
  columnTitle: {
    color: '#27343d',
    fontFamily: 'Lato',
    fontSize: 11,
    fontWeight: 900,
  },
  smallText: {
    color: '#27343d',
    fontWeight: 400,
    fontSize: 9,
    fontFamily: 'Lato',
  },

  progressBarContainer: {
    width: '100%',
    height: 7,
    backgroundColor: '#D8DBE5',
    borderRadius: 3,
    marginTop: 2,
    padding: 2,
  },
  progressBarFill: {
    height: '100%',
    borderRadius: 3,
  },
  rowSpaceBetween: {
    display: 'flex',
    flexDirection: 'row',
    justifyContent: 'space-between',
  },

  statisticsGrid: {
    display: 'flex',
    flexDirection: 'row',
    flexWrap: 'wrap',
    justifyContent: 'flex-start',
    rowGap: 10,

    width: '100%',
    marginBottom: 20,
  },
  statisticsItem: {
    width: '33%',
    flexDirection: 'row',
    gap: 5,
  },
  textWrapper: {
    flex: 1,
  },
  statTitle: {
    color: '#27343d',
    fontSize: 14,
    fontWeight: 900,
    fontFamily: 'Lato',
  },
  statDescription: {
    color: '#27343d',
    fontSize: 9,
    fontWeight: 400,
    fontFamily: 'Lato',
  },

  furtherInformationWrapper: {
    display: 'flex',
    flexDirection: 'row',
    alignItems: 'center',
    gap: 5,
    marginTop: 5,
  },
  furtherInformationLink: {
    color: '#27343d',
    fontFamily: 'Lato',
    fontWeight: 400,
    fontSize: 10,
    textDecoration: 'none',
  },
});
